import React from 'react';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import './DistributorAppAccess.css';

function DistributorAppAccess({ enabled, onToggle, disabled }) {
    return (
        <div className="flex flex-col items-end gap-1.5">
            <label htmlFor="distributor-app-access" className="flex items-center gap-[5px] cursor-pointer">
                <span className="text-[21px] leading-4 text-[#090406]">Distributor Application Access</span>
                <Toggle
                    id="distributor-app-access"
                    className="distributor-access-toggle"
                    checked={enabled}
                    icons={false}
                    disabled={disabled}
                    onChange={onToggle}
                />
            </label>
            <div className="flex items-center gap-2">
                <p className={`text-base leading-5 font-semibold ${enabled ? 'text-[#36AC66]' : 'text-[#ED1C24]'}`}>
                    {enabled ? 'Distributor application is live' : 'Distributor application is offline'}
                </p>
                <div
                    className={`flex items-center justify-center w-6 h-6 rounded-xl ${enabled ? 'bg-[#E2FFEC]' : 'bg-[#FFE3E4]'}`}
                >
                    <img
                        src={enabled ? '/images/distributor-app-live.svg' : '/images/distributor-app-offline.svg'}
                        alt=""
                        width="14"
                        height="14"
                    />
                </div>
            </div>
        </div>
    );
}

export default DistributorAppAccess;
